import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import './helpers/ExceptionHandler/globleException';
import { registerForPush, listenForForegroundMessages } from "./push-client";

import {
    fetchMenu,
    getPlayerProfileDetail,
    fetchOtherMediaInfo,
    fetchCssInfo,
    fetchComponentSetting,
    fetchMetaInfo,
    fetchFooterInfo,
    fetchSubMenu,
    getMemoCount,
    fetchDepositPending
} from "./store/actions";

// Ajax import
import {
    makeAjax,
    url,
    respStatus,
    prevetHeaderLoad,
} from "./helpers/global_helper";
// Mobile & desktop header , footer
import HeaderMobile from "./layout/header-mobile/HeaderMobile";
import FooterMobile from "./layout/footer-mobile/FooterMobile";
import Header from "./layout/header/Header";
import Footer from "./layout/footer/Footer";
import VerticalNav from "./layout/header/navbar/VerticalNav";
// Default css import

import ThemeMode from "./components/ThemeMode/ThemeMode";
import { ThemeModeContext } from "./components/ThemeMode/Context";

import Popup from "./components/popup/Popup";
import RouteHandle from "./pages/user-pages/RouteHandle";
import MetaInfoConfig from "./pages/MetaInfoConfig";
import TogelGameBlock from "./components/popup/popup-components/TogelGameBlock";
// import './jayabet.css';  // NOSONAR
// import './custom.css';  // NOSONAR
// import './wigobet.css';  // NOSONAR
// import './template7.css';  // NOSONAR
// import './skeleton.css';  // NOSONAR


import {
    authProtectedRoutes,
    publicRoutes,
    bothRoutes,
    specialRoutes
} from "./routes";
import Cookies from "js-cookie";
import { fetchCategoryGameCount } from "./store/category-game-count/actions";
import { UpdateSocialMediaPlayerCount } from "./pages/UpdateSocialMediaPlayerCount";
import NetworkApiFailures from "./components/popup/popup-components/NetworkApiFailures";

const App = () => {
    const lastDateRef = useRef(null);
    const [isCssLoaded, setIsCssLoaded] = useState(false);
    const checkCssLoad = () => {
        // check index.html
        if (localStorage.getItem('theme_css'))
            setIsCssLoaded(true);
        else {
            setTimeout(() => {
                checkCssLoad();
            }, 50);
        }
    };
    useEffect(() => {
        checkCssLoad();
    }, []);
    const checkKeyStatus = (key) => {
        const storedDate = localStorage.getItem(key);

        if (storedDate == null) {
            return true;
        } else {
            const currentDate = new Date();
            const targetDate = new Date(storedDate);
            const timeDifferenceInHours =
                (currentDate - targetDate) / (1000 * 60 * 60);
            return timeDifferenceInHours > 24;
        }
    };

    const { referral } = useParams();

    // No header page url
    const noHeadFoot = [
        "new-password",
        "login-pin",
        "security-question",
        "rules-of-play",
        "security-validation",
        "pin-security-validation",
        "reminder-password",
        "update-token",
        "unauthorised401",
        "error404",
        "accessdenied",
        "livechat",
        "access-denied",
        "blank-screen",
        'change-password',
        'robots.txt',
        'undermaintenance'
    ];

    // Redirection routes 
    let redirectArr = [
        "/login-pin",
        "/security-question",
        "/security-validation",
        "/reminder-password",
        '/change-password',
    ];

    // Special routes
    const specialRestrictedRoute = ["/access-denied"];

    // No theme load
    const noThemeModeRoute = ["/blank-screen", "/robots.txt"];

    // States & hooks define
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [isComingSoon, setComingSoon] = useState(false);
    const [isAdminPopup, setAdminPopup] = useState(false);
    const [enablePage, setEnablePage] = useState("N");
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [sideMenuClickPropState, setSideMenuClickPropState] = useState(false);
    const [isWindowWidthGreaterThan991, setIsWindowWidthGreaterThan991] = useState(window.innerWidth > 991);
    const [mobileHeaderType, setMobileHeaderType] = useState('');
    const [contryBlocked, setCountryBlocked] = useState(false);
    const [themeMode, setThemeMode] = useState(localStorage.getItem('mode'));
    const [socialMediaSource, setSocialMediaSource] = useState(null);
    const [hkbProviderDeposit, setHKBProviderDeposit] = useState('');
    const [invalidApiResp, setInvalidApiResp] = useState(false);
    const [invalidRespPopup, setInvalidRespPopup] = useState(null);
    const [toggleGameBlock, setToggleGameBlock] = useState(false);
    const [toggleGameBlockApi, setToggleGameBlockApi] = useState(null);
    const [lastServerDate, setLastServerDate] = useState(null);
    const [timeOffset, setTimeOffset] = useState(null);

    // Getting data from redux
    const { componentSetting, providerSubMenuList, userProfile } = useSelector((state) => ({
        componentSetting: state.componentSettingListR.data,
        providerSubMenuList: state.submenuListR.data,
        userProfile: state.playerProfileR?.data ?? {},
    }));

    const [token, setToken] = useState(null);
    const [msg, setMsg] = useState(null);

    // Getting local storage & path
    const isVerticalActive = componentSetting?.["nav-bar"]?.["default-value"] === 'vertical' &&
        (componentSetting?.["vertical-nav-bar"]?.["default-value"] === 'left' || componentSetting?.["vertical-nav-bar"]?.["default-value"] === 'right');
    let status = window.localStorage.getItem('admin_pass_status');
    const restrictedUrl = window.location.pathname;
    let params = window.location.pathname.substring(1);
    let userToken = window.localStorage.getItem("user_token");

    // Function call for checking access denied page
    const afterADC = () => {
        if (userToken != null && userToken != "") {
            dispatch(getPlayerProfileDetail());
            dispatch(getMemoCount());
            dispatch(fetchDepositPending());
        }
        if (!prevetHeaderLoad.includes(restrictedUrl)) {
            dispatch(fetchMenu());
            dispatch(fetchComponentSetting());
            dispatch(fetchCategoryGameCount())
            dispatch(fetchMetaInfo());
            dispatch(fetchFooterInfo());
        }
    };

    // Funcion call for checking sec, change pass, pin, reminder pass etc 
    const getPinStatus = () => {
        makeAjax(url.USER_API.checkIfPinAlreadySet, [], url.USER_MS_EXT)
            .then((response) => {
                let resp = response.data;
                if (response.status != respStatus["SUCCESS"]) {
                    setEnablePage("Y");
                    return;
                }
                if (resp) {
                    let config_status = resp.get_tenant_config?.value;
                    if (
                        config_status === true &&
                        resp.enabled_active_pin === true &&
                        resp.active_pin === false &&
                        !redirectArr.includes(location.pathname)
                    ) {
                        navigate("/login-pin");
                        setEnablePage("Y");
                        return;
                    } else if (
                        config_status === true &&
                        resp.enabled_active_pin === true &&
                        resp.is_pin_verified === false &&
                        !redirectArr.includes(location.pathname)
                    ) {
                        navigate("/security-validation");
                        setEnablePage("Y");
                        return;
                    } else if (
                        (resp.is_security_question_set === false ||
                            resp.is_security_question_set === null) &&
                        !redirectArr.includes(location.pathname)
                    ) {
                        navigate("/security-question");
                        setEnablePage("Y");
                        return;
                    } else if (
                        resp.is_password_active === false &&
                        !redirectArr.includes(location.pathname)
                    ) {
                        navigate("/reminder-password");
                        setEnablePage("Y");
                        return;
                    } else if (resp?.admin_reset && resp.is_pin_verified == true) {
                        navigate("/change-password");
                        return;
                    }
                    setEnablePage("Y");
                } else if (redirectArr.includes(location.pathname)) {
                    navigate("/");
                    setEnablePage("Y");
                    return;
                }
                setEnablePage("Y");
                setMobileHeaderType('after');
            })
            .catch((ex) => {
                if (redirectArr.includes(location.pathname)) {
                    navigate("/");
                    setEnablePage("Y");
                    return;
                }
                setEnablePage("Y");
            });
    };

    // Function call for checking login status
    const isLoggedIn = () => {
        makeAjax(url.USER_API.isLoggedIn, {}, url.USER_MS_EXT).then((response) => {
            if (response.code != "validation.access_denied") {
                afterADC();
                setEnablePage("Y");
                if (location.pathname == '/access-denied')
                    navigate('/');
            } else {
                setEnablePage("N");
                navigate("/access-denied");
            }
        });
    };

    // Function call for side menu handle
    const sideMenuClickProp = () => {
        setSideMenuClickPropState((curr) => !curr);
    };



    // Handle global popups
    const handleClose = (code) => {
        if (code) {
            if (code == 'hkb-transactions') {
                handlePopup();
                return;
            }
            navigate(`/${code}`);
        }
    };

    // Handle close popups
    const handlePopup = () => {
        setComingSoon(!isComingSoon);
    };

    // Handle close popups
    const handlePopupAdminPass = () => {
        setAdminPopup(false);
        localStorage.setItem('admin_pass_status', false);
    };

    useEffect(() => {
        let hkbProviderDepositUrl = (new URLSearchParams(location.search)).get('gt');
        let social_media_platform = (new URLSearchParams(location.search)).get('source');
        const social_media_arr = ["telegram", "instagram", "facebook"];
        social_media_platform = social_media_arr.includes(social_media_platform) ? social_media_platform : null;
        setSocialMediaSource(social_media_platform);
        if(hkbProviderDepositUrl){
            setHKBProviderDeposit(true);
        }
    }, [location]);

    // Effect call to load data based on device
    useEffect(() => {
        if (!userToken) {
            Cookies.remove("gameWindow");
            Cookies.remove("gameObject");
        }
        if (!specialRestrictedRoute.includes(restrictedUrl) && !contryBlocked)
            isLoggedIn();

        const handleWindowWidth = () => {
            setWindowWidth(window.innerWidth);
            setIsWindowWidthGreaterThan991(window.innerWidth > 991);
        };
        if (status == 'true')
            setAdminPopup(true);
        if (isVerticalActive) {
            if (isWindowWidthGreaterThan991) {
                document.body.classList.add('vertical-nav-active');
                document.body.classList.remove('replace-class');
            }
            else {
                document.body.classList.remove('vertical-nav-active');
                document.body.classList.add('replace-class');
            }
        } else {
            document.body.classList.remove('vertical-nav-active', 'replace-class');
        }
        window.addEventListener("resize", handleWindowWidth);
        return () => {
            window.removeEventListener("resize", handleWindowWidth);
        };
    }, [userToken, status, isVerticalActive, isWindowWidthGreaterThan991, contryBlocked]);

    useEffect(() => {
        if (!prevetHeaderLoad.includes(restrictedUrl) && enablePage == 'Y' && userToken && params != 'change-password') {
            getPinStatus();
        }
    }, [params]);

    useEffect(() => {
        dispatch(fetchCssInfo());

        if (window.location.href.includes("email-verify")) return;

        const allRoutesList = getAllRoutesList();
        const pathname = getPathname();
        if (handleReferralNavigation(pathname)) return;
        if (handleRegisterNavigation(pathname)) return;
        handleUnauthorizedNavigation(pathname, allRoutesList);

        fetchBlockedCountryList();
    }, []);

    useEffect(() => {
        const handler = (e) => {
            setInvalidRespPopup(e.detail);
            setInvalidApiResp(true);
        };
        window.addEventListener("showInvalidApiResponseModal", handler);
        return () => {
            window.removeEventListener("showInvalidApiResponseModal", handler);
        };
    }, []);

    // Helper function to get all routes list
    const getAllRoutesList = () => {
        let allRoutes = [...publicRoutes, ...bothRoutes, ...specialRoutes];

        if (userToken) allRoutes = [...allRoutes, ...authProtectedRoutes];

        const allRoutesSet = new Set();
        allRoutes.forEach(route => {
            const pathParts = route.path.split('/');
            if (pathParts[1]?.trim()) allRoutesSet.add(pathParts[1]);
        });

        providerSubMenuList && Object.values(providerSubMenuList).forEach(provider => {
            if (provider?.main_provider?.url_slug) allRoutesSet.add(provider.main_provider.url_slug);
            if (provider?.url_slug) allRoutesSet.add(provider.url_slug);
        });

        return allRoutesSet;
    };

    // Helper function to get cleaned pathname
    const getPathname = () => {
        return location.pathname.startsWith('/') ? location.pathname.substring(1) : location.pathname;
    };

    // Handle referral navigation
    const handleReferralNavigation = (pathname) => {
        if (!window.location.pathname.startsWith("/referral/")) return;
        navigate('/register');
    };

    // Handle navigation to register page for logged-in users
    const handleRegisterNavigation = (pathname) => {
        if (userToken && pathname === "register") {
            navigate('/');
            return true;
        } else {
            return false;
        }
    };

    // Handle unauthorized navigation
    const handleUnauthorizedNavigation = (pathname, allRoutesList) => {
        const isPathAllowed = allRoutesList.has(pathname) || ["result", "blogs", "undermaintenance"].some(keyword => window.location.href.includes(keyword));

        // if (!isPathAllowed) {
        //     localStorage.removeItem('referral_username');
        //     navigate('/');
        // }
    };

    // Fetch blocked country list
    const fetchBlockedCountryList = async () => {
        try {
            const response = await makeAjax(url.USER_API.getBlockedCountryList, [], url.USER_MS_EXT);
            if (!response) return;
            if (response.code === 'validation.access_denied') {
                setEnablePage('N');
                setCountryBlocked(true);
                if (window.location.pathname !== '/access-denied') navigate('/access-denied');
            } else {
                setEnablePage('Y');
                if (contryBlocked) setCountryBlocked(false);
                if (window.location.pathname === '/access-denied') navigate('/');
            }
        } catch (error) {
            console.error('Error fetching blocked country list:', error);
        }
    };

    useEffect(() => {
        if (userToken != null && userToken != "") {

            if (userProfile && userProfile?.theme_mode) {
                localStorage.setItem('mode', userProfile.theme_mode);
                setThemeMode(userProfile.theme_mode);
            }
        }
    }, [userProfile?.theme_mode]);

    useEffect(() => {
        dispatch(fetchOtherMediaInfo(themeMode));
        dispatch(fetchSubMenu(themeMode));
    }, [themeMode]);

    useEffect(() => {
        if (socialMediaSource) {
            console.log("inside social media app.js", socialMediaSource);
            localStorage.setItem("actual_device", socialMediaSource);
            UpdateSocialMediaPlayerCount(socialMediaSource);
        }
    }, [socialMediaSource]);

    useEffect(() => {
        if (hkbProviderDeposit) {
            localStorage.setItem("hkb_provider_deposit", true);
        }
    }, [hkbProviderDeposit]);

    useEffect(() => {
        const handlerTogel = (e) => {
            setToggleGameBlock(true);
            setToggleGameBlockApi(e.detail);
        };
        window.addEventListener("showBlockTogelGameCategoryModal", handlerTogel);
        return () => {
            window.removeEventListener("showBlockTogelGameCategoryModal", handlerTogel);
        };
    }, []);

    useEffect(() => {
        if (userProfile?.last_login_at) {
            const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const initialDate = new Date(
                new Date(userProfile?.last_login_at).toLocaleString("en-US", {
                    timeZone: userTimeZone,
                })
            ).toISOString().split("T")[0];
            lastDateRef.current = initialDate;
        }
        const interval = setInterval(() => {
            if (userProfile?.last_login_at) {
                const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                //the current date in the user's timezone
                const nowDate = new Date(
                    new Date().toLocaleString("en-US", {
                        timeZone: userTimeZone,
                    })
                ).toISOString().split("T")[0];

                if (lastDateRef.current !== nowDate) {
                    lastDateRef.current = nowDate;
                    dispatch(getPlayerProfileDetail());
                }
            }
        }, 5000);
        return () => {
            clearInterval(interval);
        };
    }, [userProfile?.last_login_at, dispatch]);

    useEffect(() => {
        listenForForegroundMessages(p => setMsg(p));
    }, []);

    console.log();

    return (
        <>
            <MetaInfoConfig />
            {invalidApiResp && <NetworkApiFailures data={invalidRespPopup} onClose={() => setInvalidApiResp(false)} />}
            {toggleGameBlock && <Popup togelGameBlock={toggleGameBlock} handlePoup={() => (setToggleGameBlock(false), setToggleGameBlockApi(null))} />}
            {
                isCssLoaded ?
                    (
                        <ThemeModeContext.Provider value={{ themeMode, setThemeMode }}>
                            <div className="dark-light-mode">
                                <div className={componentSetting?.["vertical-nav-bar"]?.["default-value"] == 'left' && !sideMenuClickPropState && componentSetting?.["nav-bar"]["default-value"] == 'vertical' ? 'vertical-nav-main' : componentSetting?.["vertical-nav-bar"]?.["default-value"] == 'right' && !sideMenuClickPropState && componentSetting?.["nav-bar"]["default-value"] == 'vertical' ? 'vertical-nav-main vertical-nav-main-right' : 'vertical-navbar-open'}>
                                    {!specialRestrictedRoute.includes(restrictedUrl) &&
                                        <>
                                            {windowWidth > 991 && !prevetHeaderLoad.includes(restrictedUrl) && !noHeadFoot.includes(window.location.pathname.split('/')[1]) &&
                                                componentSetting?.["nav-bar"]?.["default-value"] == 'vertical' &&
                                                <VerticalNav sideMenuClickPropState={sideMenuClickPropState} handleClose={handleClose} />
                                            }
                                        </>
                                    }
                                    <div className="main">

                                        {!specialRestrictedRoute.includes(restrictedUrl) &&
                                            <>
                                                {windowWidth > 991 ? <>{!prevetHeaderLoad.includes(restrictedUrl) && !noHeadFoot.includes(window.location.pathname.split('/')[1]) && <Header sideMenuClickProp={sideMenuClickProp} />} </> : <>{!prevetHeaderLoad.includes(restrictedUrl) && !noHeadFoot.includes(window.location.pathname.split('/')[1]) && <HeaderMobile type={mobileHeaderType} />}</>}
                                            </>
                                        }
                                        <div className="sub-main">
                                            <RouteHandle renderSpecialRoutes={contryBlocked} />
                                        </div>
                                        <div className="skeleton-footer">
                                            {!specialRestrictedRoute.includes(restrictedUrl) &&
                                                <>
                                                    {windowWidth > 991 ? <>{!prevetHeaderLoad.includes(restrictedUrl) && !noHeadFoot.includes(window.location.pathname.split('/')[1]) && <Footer />} </> : <>{!noHeadFoot.includes(window.location.pathname.split('/')[1]) && <FooterMobile />} </>}
                                                </>
                                            }
                                        </div>
                                    </div>
                                </div>
                                {isComingSoon && <Popup handlePoup={handlePopup} comingSoon />
                                }
                                {isAdminPopup && <Popup handlePoup={handlePopupAdminPass} adminPasswordChange />}
                                {!noThemeModeRoute.includes(restrictedUrl) &&
                                    <div className="light-dark-mode">
                                        <ThemeMode />
                                    </div>
                                }
                            </div>
                        </ThemeModeContext.Provider >)
                    : null
            }
        </>
    )
};

export default App;